export default {
  name: "Las Vegas ReLeaf",
  dates: "Oct 2015 – Apr 2017",
  title: "Manager",
  bullets: [
    "Managed the daily operations of the first dispensary in one of the most regulated US markets. Entered purchase orders, corrected cannabis laboratories’ concentration percentage calculations, and created user friendly discount calculation guides.",
    "Developed compliant POS, inventory, & financial reporting system a highly regulated cannabis dispensary ran on for 2+ months during industry outage, processing $200,000+ in sales.",
    "Built it in Excel VBA the day the industry’s POS vendor went down: paper worksheets first, then barcode scanning, inventory decrement, and printed receipts, while other dispensaries closed for lack of a compliant way to sell.",
    "Reassigned by the COO from floor management to build it full time; state inspectors visited to see it in person.",
  ],
};
